export default __webpack_public_path__ + "2625c30cf76b7494614edbc0fccb00cc.svg";